<script>
  import { createEventDispatcher } from "svelte";
  import { children } from "svelte/internal";

  export let categories = [];

  let className = "";
  export { className as class };

  const dispatch = createEventDispatcher();

  const expandCategory = (ev, category) => {
    ev.target.classList.toggle("caret-down");
    ev.target.classList.toggle("caret-up");
  };

  const selectCategory = (ev, category) => {
    category.selected = !category.selected;

    selectParentCategories(category);

    categories = categories;

    if (category) categorySelected(category);
  };

  function selectParentCategories(category) {
    if (category.parent_node !== null) {
      category.parent_node.selected = category.parent_node.children.some(
        (el) => el.selected
      );
      selectParentCategories(category.parent_node);
    }
  }

  const categorySelected = (category) => {
    console.log("checked category:" + category);

    dispatch("categorySelected", { category });
  };
</script>

<ul class="product-categories {className}">
  {#each categories as category}
    <li
      class="cat-item cat-item-{category.term_id} {category.children?.length < 1
        ? 'no-caret'
        : 'caret'} {category.children?.some((ctg) => ctg.selected)
        ? 'caret-down'
        : 'caret-up'}"
      on:click|stopPropagation={(ev) => expandCategory(ev, category)}
    >
      <div on:click|stopPropagation={(ev) => selectCategory(ev, category)}>
        <input
          type="checkbox"
          value={category.term_id}
          bind:checked={category.selected}
          on:change={(ev) => {
            /*categorySelected(category)*/
          }}
        />
        <span
          >{category.name} <span class="count">({category.count})</span></span
        >
      </div>
      <svelte:self
        bind:categories={category.children}
        class="nested"
        on:categorySelected
      />
    </li>
  {/each}
</ul>

<style>
  ul,
  .product-categories {
    list-style-type: none;
  }

  .product-categories {
    margin: 0;
    padding: 0;
  }

  .caret::before {
    line-height: 1;
    text-align: center;
  }

  .no-caret::before {
    content: "";
    visibility: hidden;
  }

  /* Rotate the caret/arrow icon when clicked on (using JavaScript) */
  .caret-down::before {
    transform: rotate(90deg);
  }

  /* Hide the nested list */
  :global(.caret-up > .nested) {
    display: none;
  }

  /* Show the nested list when the user clicks on the caret/arrow (with JavaScript) */
  :global(.caret-down > .nested) {
    display: block;
  }

  ul li,
  ul ul {
    margin-left: 10px;
  }

  input[type="checkbox"] {
    vertical-align: text-top;
  }
</style>
